/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface Stripe
 */
export interface Stripe {
    /**
     * 
     * @type {number}
     * @memberof Stripe
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Stripe
     */
    courierId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Stripe
     */
    isStripeApiEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Stripe
     */
    restrictedKey?: string;
    /**
     * Signing secret (whsec_...) of the courier's own Stripe webhook endpoint. Stored encrypted.
     * @type {string}
     * @memberof Stripe
     */
    webhookSecret?: string;
}

/**
 * Check if a given object implements the Stripe interface.
 */
export function instanceOfStripe(value: object): value is Stripe {
    return true;
}

export function StripeFromJSON(json: any): Stripe {
    return StripeFromJSONTyped(json, false);
}

export function StripeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stripe {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'isStripeApiEnabled': json['isStripeApiEnabled'] == null ? undefined : json['isStripeApiEnabled'],
        'restrictedKey': json['restrictedKey'] == null ? undefined : json['restrictedKey'],
        'webhookSecret': json['webhookSecret'] == null ? undefined : json['webhookSecret'],
    };
}

export function StripeToJSON(json: any): Stripe {
    return StripeToJSONTyped(json, false);
}

export function StripeToJSONTyped(value?: Stripe | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        'id': value['id'],
        'courierId': value['courierId'],
        'isStripeApiEnabled': value['isStripeApiEnabled'],
        'restrictedKey': value['restrictedKey'],
        'webhookSecret': value['webhookSecret'],
    };
} 